import actions from './actions';
import mutations from './mutations';

const getInitialState = () => ({
  error: null,
  isLoading: false,
  hasFetched: false,
  data: [],
});

export default {
  actions,
  mutations,
  namespaced: true,
  state: getInitialState(),
};
